import {
  APPLIED_FILTER_OPERATOR_EQUALS,
  APPLIED_FILTER_OPERATOR_NOT_EQUALS,
  APPLIED_FILTER_OPERATOR_GREATER_THAN,
  APPLIED_FILTER_OPERATOR_GREATER_THAN_OR_EQUAL_TO,
  APPLIED_FILTER_OPERATOR_LESS_THAN,
  APPLIED_FILTER_OPERATOR_LESS_THAN_OR_EQUAL_TO,
  APPLIED_FILTER_OPERATOR_CONTAINS,
  APPLIED_FILTER_OPERATOR_NOT_CONTAINS,
  APPLIED_FILTER_OPERATOR_STARTS_WITH,
  APPLIED_FILTER_OPERATOR_ENDS_WITH,
  APPLIED_FILTER_OPERATOR_EQUALS_TRUE,
  APPLIED_FILTER_OPERATOR_EQUALS_FALSE,
  APPLIED_FILTER_OPERATOR_SHORT_EQUALS,
  APPLIED_FILTER_OPERATOR_SHORT_NOT_EQUALS,
} from '../../../../components/filter-editor/constants/applied-filter-operator';

export type FilterCondition = {
  fieldType: string;
  operator: string;
  value: string;
};

const reverseOperatorMap: Record<string, string> = {
  [APPLIED_FILTER_OPERATOR_EQUALS]: 'equals',
  [APPLIED_FILTER_OPERATOR_NOT_EQUALS]: 'notEquals',
  [APPLIED_FILTER_OPERATOR_GREATER_THAN]: 'greaterThan',
  [APPLIED_FILTER_OPERATOR_GREATER_THAN_OR_EQUAL_TO]: 'greaterThanOrEqualTo',
  [APPLIED_FILTER_OPERATOR_LESS_THAN]: 'lessThan',
  [APPLIED_FILTER_OPERATOR_LESS_THAN_OR_EQUAL_TO]: 'lessThanOrEqualTo',
  [APPLIED_FILTER_OPERATOR_CONTAINS]: 'contains',
  [APPLIED_FILTER_OPERATOR_NOT_CONTAINS]: 'doesNotContain',
  [APPLIED_FILTER_OPERATOR_STARTS_WITH]: 'startsWith',
  [APPLIED_FILTER_OPERATOR_ENDS_WITH]: 'endsWith',
  [APPLIED_FILTER_OPERATOR_SHORT_EQUALS]: 'equals',
  [APPLIED_FILTER_OPERATOR_SHORT_NOT_EQUALS]: 'notEquals',
  [String(APPLIED_FILTER_OPERATOR_EQUALS_TRUE)]: 'valueEqualsTrue',
  [String(APPLIED_FILTER_OPERATOR_EQUALS_FALSE)]: 'valueEqualsFalse',
};

export const reverseMapFilters = (appliedFilters: Record<string, unknown[]>): FilterCondition[] => {
  const conditions: FilterCondition[] = [];

  for (const category of Object.keys(appliedFilters)) {
    const filters = appliedFilters[category] as Array<Record<string, unknown>>;
    if (!Array.isArray(filters)) continue;

    for (const filter of filters) {
      const fieldType = (filter.column as string) ?? '';
      let operator = 'equals';
      let value = '';

      if (filter.isIn === true) {
        operator = 'includes';
        const values = filter.values as string[] | undefined;
        value = values?.[0] ?? '';
      } else if (filter.isIn === false) {
        operator = 'doesNotInclude';
        const values = filter.values as string[] | undefined;
        value = values?.[0] ?? '';
      } else if (filter.isNull === true) {
        operator = 'valueAreEmpty';
      } else if (filter.isNull === false) {
        operator = 'valueAreNotEmpty';
      } else if (filter.operator != null) {
        operator = reverseOperatorMap[String(filter.operator)] ?? String(filter.operator);
        value = String(filter.value ?? '');
      }

      conditions.push({ fieldType, operator, value });
    }
  }

  return conditions;
};
